import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.50131 0C0.673266 0 0 0.672397 0 1.50184V19.4982C0 20.331 0.672158 21 1.50131 21H3.15762L4.35 24L7.50288 21H22.4987C23.3267 21 24 20.3276 24 19.4982V1.50184C24 0.669036 23.3278 0 22.4987 0H1.50131Z",
      fill: "#D4002B"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "8.10001",
      cy: "6.30005",
      r: "1.5",
      fill: "white"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "15.9",
      cy: "6.30005",
      r: "1.5",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M6.71634 14.1506C6.8008 14.0794 6.94761 13.9663 7.15169 13.8254C7.48404 13.596 7.86289 13.3676 8.28347 13.1547C11.1947 11.6809 14.3566 11.6809 17.2837 14.1506C17.6002 14.4178 17.6403 14.8909 17.3732 15.2075C17.1061 15.5241 16.6329 15.5642 16.3163 15.2971C13.9101 13.2668 11.3831 13.2668 8.96097 14.493C8.60378 14.6738 8.28262 14.8674 8.00386 15.0598C7.84127 15.1721 7.73253 15.2558 7.68365 15.2971C7.36707 15.5642 6.89389 15.5241 6.62678 15.2075C6.35967 14.8909 6.39976 14.4178 6.71634 14.1506Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }